import { useEffect, useMemo, useState } from "react";
import CheckList from "../../Reusables/CheckList/CheckList";
import "./lgvCheckList.css";
import Button from "../../Reusables/Button/Button";
import Arrow from "../../../assets/icons/arrow.png";
import { formatLgvListToCheckListWithData } from "../../../util/helper/navHeatmap/navHeatmapHelper";

const LgvCheckList = ({ data, allLgv, onChange }) => {
  const [lgvCheckListData, setLgvCheckListData] = useState(null);

  useEffect(() => {
    if (data && allLgv) {
      const formattedLgvCheckList = formatLgvListToCheckListWithData(
        data,
        allLgv
      );
      setLgvCheckListData(
        formattedLgvCheckList.length !== 0 ? formattedLgvCheckList : []
      );
    }
  }, []);

  const RenderCheckList = useMemo(() => {
    if (lgvCheckListData !== null) {
      return <CheckList options={lgvCheckListData} onChange={onChange} />;
    }
  }, [lgvCheckListData]);

  return (
    <div className="lgv-check-list-container">
      <Button
        placeholder="LGVs"
        btnClass="reverse-content box-shadow"
        imgClass="reverse-content-img"
        icon={Arrow}
      />
      {RenderCheckList}
    </div>
  );
};

export default LgvCheckList;
